<template>
  <div class="nl">
    <div class="nl-head">
      <fa-icon icon="quote-left" /> <strong>Resumo em linguagem natural</strong>
    </div>
    <div class="nl-body" v-if="resumo">{{ resumo }}</div>
    <div class="nl-empty" v-else>Adicione condições para visualizar o resumo.</div>
  </div>
</template>

<script>
const OP_LABELS = {
  igual: 'igual a',
  diferente: 'diferente de',
  maior: 'maior que',
  menor: 'menor que',
  maior_igual: 'maior ou igual a',
  menor_igual: 'menor ou igual a',
  em: 'está em',
  nao_em: 'não está em',
  entre: 'entre',
  contem: 'contém',
  nulo: 'é nulo',
  nao_nulo: 'não é nulo',
};

export default {
  name: 'AcaoObjetoNlPreview',
  props: {
    conditionType: { type: String, default: 'visual' },
    conditionVisual: { type: Object, default: null },
    conditionSql: { type: String, default: '' },
    regras: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    eventoNome: { type: String, default: '' },
    validarTodasRegras: { type: Boolean, default: true },
  },
  computed: {
    fieldLabel() {
      const map = {};
      (this.fields || []).forEach(f => { map[f.name] = f.label || f.name; });
      return map;
    },
    resumo() {
      const prefix = this.eventoNome ? `Quando ocorrer "${this.eventoNome}", disparar se ` : 'Disparar se ';

      if (this.conditionType === 'sql') {
        const t = (this.conditionSql || '').trim();
        if (!t) return null;
        return `${prefix}a query SQL retornar pelo menos 1 linha.`;
      }

      if (this.conditionType === 'visual') {
        const grupos = (this.conditionVisual && this.conditionVisual.grupos) || [];
        const partes = grupos.map(g => this.descreverGrupo(g)).filter(Boolean);
        if (!partes.length) return null;
        const sep = ' OU ';
        return `${prefix}${partes.join(sep)}.`;
      }

      // default
      const r = (this.regras || []).map(x => this.descreverRegra(x)).filter(Boolean);
      if (!r.length) return null;
      const sep = this.validarTodasRegras ? ' E ' : ' OU ';
      return `${prefix}${r.join(sep)}.`;
    },
  },
  methods: {
    descreverGrupo(g) {
      const conds = (g.condicoes || [])
        .filter(c => c.campo)
        .map(c => this.descreverCondicao(c));
      if (!conds.length) return '';
      const sep = (g.logica === 'OR') ? ' OU ' : ' E ';
      return conds.length > 1 ? `(${conds.join(sep)})` : conds[0];
    },
    descreverCondicao(c) {
      const campo = this.fieldLabel[c.campo] || c.campo;
      const op = OP_LABELS[c.operador] || c.operador;
      const semValor = ['nulo', 'nao_nulo'].includes(c.operador);
      if (semValor) return `${campo} ${op}`;
      const valor = (c.valor === '' || c.valor == null) ? '?' : c.valor;
      return `${campo} ${op} "${valor}"`;
    },
    descreverRegra(r) {
      if (!r || !r.coluna) return '';
      return `${r.coluna} ${r.condicao || '='} "${r.valor}"`;
    },
  },
};
</script>

<style scoped>
.nl {
  background: linear-gradient(135deg, #f9fafb 0%, #f2f2f8 100%);
  border: 1px solid #dddce9;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 14px;
}
.nl-head { font-size: 11px; color: #3a3e81; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 6px; }
.nl-head strong { font-weight: 700; }
.nl-body { font-size: 13px; color: #1d2939; line-height: 1.55; }
.nl-empty { font-size: 12px; color: #98a2b3; font-style: italic; }
</style>
